import { useState, useEffect, React } from "react";
import { Grid, Column, FlexGrid, Row, SelectItem, Select, Loading, Checkbox, InlineNotification, Button, Modal, Form } from '@carbon/react';
import PermisosTable from './PermisosTable'
import { ModulosService, PerfilService } from "../../../../services";
import Style from './PermisosTab.module.scss'
import { buttonEvents } from "../../../../utils/FormUtil";
import Cookies from "universal-cookie";

export const CheckboxPermisos = ({ id, obj, labelText, permiso, onChangeItem, disabled }) => {
  const [isChecked, setIsChecked] = useState(obj[permiso]);
  function handleClick(checked) {
    setIsChecked(checked);
    onChangeItem(obj, permiso, !isChecked);
  }
  return (
    <Checkbox labelText={labelText} id={"chk-" + id} disabled={disabled} checked={isChecked} onChange={(e, { checked }) => handleClick(checked)} />
  )
}

export const PermisosTab = () => {
  const cookies = new Cookies();

  const [modulos, setModulos] = useState([]);
  const [modulosPerfil, setModulosPerfil] = useState([]);
  const [perfiles, setPerfiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [styleBox, setStyleBox] = useState(Style.hideBox);
  const [notificationKind, setNotificationKind] = useState('');
  const [notificationTitle, setNotificationTitle] = useState('');
  const [open, setOpen] = useState(false);
  const [disabledButton, setDisabledButton] = useState(true);
  const [disabledButtonModal, setDisabledButtonModal] = useState(true);
  const [perfilSeleccionado, setPerfilSeleccionado] = useState('');
  const [moduloSeleccionado, setModuloSeleccionado] = useState('');

  //const[isBtnAddModuloDisabled, setIsBtnAddModuloDisabled] = useState(true);
  const [isAgregarPermiso, setIsAgregarPermiso] = useState(false);
  const [isModificarPermiso, setIsModificarPermiso] = useState(false);
  const [isConsultarPermiso, setIsConsultarPermiso] = useState(false);


  function consultarPerfiles() {
    PerfilService.consultarPerfiles().then((perfiles) => {
      var ArrayPerfiles = perfiles.map(obj => {
        var rObj = {};
        rObj["id"] = obj.PerfilPerfilId;
        rObj["nombre"] = obj.PerfilNombre;
        return rObj;
      });
      setPerfiles(ArrayPerfiles);
    });
  }

  function validaPermisos() {
    let admonPermisos = cookies.get("modPermisos");

    if(admonPermisos != undefined && admonPermisos.length > 0){
      const addPermiso = (admonPermisos[0].PerfilModuloAgregar === 1)?true:false;
      setIsAgregarPermiso(addPermiso);
      setIsConsultarPermiso((admonPermisos[0].PerfilModuloConsulta === 1)?true:false);   
      setIsModificarPermiso((admonPermisos[0].PerfilModuloModificar === 1)?true:false);   
      //setDisabledButton((addPermiso)?false:true);
    }
  }

  const changeStatus = (obj, permiso, value) => {
    let reqSDTPerfil = {};
    let request = {
      PerfilModuloConsulta: obj.PerfilModuloConsulta,
      PerfilModuloModificar: obj.PerfilModuloModificar,
      PerfilModuloEliminar: obj.PerfilModuloEliminar,
      PerfilModuloAgregar: obj.PerfilModuloAgregar,
      PerfilModuloId: obj.PerfilModuloId,
    }
    request[permiso] = (value)?1:0;
    reqSDTPerfil.SDTPerfilModuloI = request;

    setLoading(true);
    ModulosService.actualizarPerfilModulo(reqSDTPerfil).then((response) => {
      buscarModuloPorPerfil(obj.PerfilModuloPerfilId);
      showNotification((response.Estatus == 0 )?'success':"error", response.Mensaje);
    }).finally(v => {
      setLoading(false);
    });
  }

  function buscarModuloPorPerfil(value) {
    if (value === "0") {
      setDisabledButton(true);
      setModulosPerfil([]);
      setPerfilSeleccionado('');
    } else {
      setLoading(true);
      setDisabledButton(isAgregarPermiso?false:true);
      
      ModulosService.consultarPermisos(value).then((modulos) => {
        var ArrayModulos = modulos.map(obj => {
          var rObj = {};
          rObj["id"] = obj.PerfilModuloId;
          rObj["nombre"] = obj.ModuloDesc;
          rObj["consultar"] = <> <CheckboxPermisos id={"consultar" + obj.PerfilModuloId} obj={obj} labelText="" permiso="PerfilModuloConsulta" onChangeItem={changeStatus} disabled={(isModificarPermiso)?false:true} /></>;
          rObj["agregar"] = <> <CheckboxPermisos id={"agregar" + obj.PerfilModuloId} obj={obj} labelText="" permiso="PerfilModuloAgregar" onChangeItem={changeStatus} disabled={(isModificarPermiso)?false:true}/></>;
          rObj["modificar"] = <> <CheckboxPermisos id={"modificar" + obj.PerfilModuloId} obj={obj} labelText="" permiso="PerfilModuloModificar" onChangeItem={changeStatus} disabled={(isModificarPermiso)?false:true}/></>;
          rObj["eliminar"] = <> <CheckboxPermisos id={"eliminar" + obj.PerfilModuloId} obj={obj} labelText="" permiso="PerfilModuloEliminar" onChangeItem={changeStatus} disabled={(isModificarPermiso)?false:true}/></>;
          return rObj;
        });
        
        setModulosPerfil(ArrayModulos);
        setPerfilSeleccionado(value);
        
      }).finally(v => {
        setLoading(false);
      });
      
    }
  }

  useEffect(() => {
    validaPermisos();
    consultarPerfiles();
  }, []);

  function showNotification(kind, msg) {
    setNotificationKind(kind);
    setNotificationTitle(msg);
    setStyleBox(Style.box);
    setTimeout(() => {
      setStyleBox(Style.hideBox)
    }, 5000);
  }

  function consultarModulos() {
    ModulosService.consultarModulos().then((modulos) => {
      var ArrayModulos = modulos.map(obj => {
        var rObj = {};
        rObj["id"] = obj.ModuloModuloId;
        rObj["nombre"] = obj.ModuloDesc;
        return rObj;
      });
      setModulos(ArrayModulos);

    });
  }

  function abrirModal() {
    consultarModulos();
    setOpen(true)
  }

  function seleccionaMudulo(value) {
    if (value === "0") {
      setDisabledButtonModal(true);
      setModuloSeleccionado('');
    } else {
      setDisabledButtonModal(false);
      setModuloSeleccionado(value);
    }
  }

  function asociarModuloPerfil() {
    let amRequest = {};
    let request = {
      PerfilModuloModuloId: Number(moduloSeleccionado),
      PerfilModuloPerfilId: Number(perfilSeleccionado),
      PerfilModuloConsulta: 0,
      PerfilModuloAgregar: 0,
      PerfilModuloModificar: 0,
      PerfilModuloEliminar: 0,
    }
    amRequest.SDTPerfilModuloII = request;
    ModulosService.asignarPermisosModulo(amRequest).then((response) => {
      showNotification((response.Estatus == 0)?'success':'error', response.Mensaje);
      setOpen(false);
      setDisabledButtonModal(true);
      setModuloSeleccionado('');
      buscarModuloPorPerfil(perfilSeleccionado);
    });
  }

  return (
    <FlexGrid>
      <Loading className={'some-class'} active={loading} withOverlay={true} />
      <Row>
        <br />
        <Form>
          <Grid>
            <Column lg={4} md={4} sm={4}>
              <Select required id="cboPerfil" labelText="Seleccione un perfil" 
                      onChange={(e) => buscarModuloPorPerfil(e.target.value)}>
                <SelectItem value="0" text="Selecciona una opción" />
                {perfiles.map((item, key) => {
                  return <SelectItem key={key} id={'o' + key} value={item.id} text={item.nombre} />
                })}
              </Select>
            </Column>
            <Column lg={4} md={4} sm={4}>
              <br />
              <Button disabled={disabledButton} {...buttonEvents} 
                      kind="primary" id="btnAddModulo" 
                      onClick={() => abrirModal()}>
                Agregar Módulo
              </Button>
            </Column>
          </Grid>
        </Form>
      </Row>
      <br /><br />
      <Row>
        <Grid>
          <Column lg={16} >
            <div className={styleBox}>
              <InlineNotification
                title={notificationTitle}
                kind={notificationKind}
                lowContrast={true} 
                hideCloseButton={true}
              />
            </div>
            <br />
            <PermisosTable rows={modulosPerfil} />
          </Column>
        </Grid>
      </Row>
      <Modal
        modalHeading="Agregar módulo"
        primaryButtonText="Agregar módulo"
        secondaryButtonText="Cancel"
        open={open}
        primaryButtonDisabled={disabledButtonModal}
        onRequestClose={() => { setOpen(false); setModuloSeleccionado(''); }}
        onRequestSubmit={() => asociarModuloPerfil()}>
        <Select id="cboModulo" labelText="Módulos" onChange={(e) => seleccionaMudulo(e.target.value)}>
          <SelectItem value="0" text="Selecciona una opción" />
          {modulos.map((item, key) => {
            return <SelectItem id={'o' + key} value={item.id} text={item.nombre} />
          })}
        </Select>
      </Modal>
    </FlexGrid>
  );
};